import { useMemo, useState } from 'react';
import { Box, ButtonBase, Dialog, IconButton, InputBase, makeStyles, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../../components/Icon';
import { baseCssBooking } from '../../baseCss';
import { i18n } from '../../../../../../language';
import { classNames } from '../../../../../../utils';
import { AutoCompleteSelect } from '../../../../../../components';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      width: '43.75rem',

      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
      backgroundColor: '#fff',
    },
  },
  root: {
    width: '43.75rem',
    maxWidth: '80rem',
    display: 'flex',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    height: '100%',
    overflow: 'auto',
    minWidth: '100%',
    flexDirection: 'column',
    padding: '1.563rem',
  },
  header: {
    justifyContent: 'space-between',
  },
  remarksTitle: {
    fontSize: '0.75rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: '#7d86a9',
  },
  confirmBtnDisabled: {
    '&.Mui-disabled': {
      backgroundColor: '#c0c6cb',
      color: '#fff',
    },
  },
}));
export default function Decline({
  closePopDecline,
  title,
  open,
  allData,
  declineAcceptBsTransferOutRequestApi,
  redirectList = [],
}) {
  const classes = useStyles();
  const baseClasses = baseCssBooking();
  const [declineData, setDeclineData] = useState({
    remark: '',
    redirWardId: null,
  });
  const showRedirectTo = useMemo(() => Array.isArray(redirectList) && redirectList.length > 0, [redirectList]);
  const buttonDisabled = useMemo(() => {
    if (showRedirectTo) {
      return !(declineData?.remark && declineData?.redirWardId);
    } else {
      return !declineData?.remark;
    }
  }, [showRedirectTo, declineData?.remark, declineData?.redirWardId]);

  const onChangeHandle = (type, val) => {
    setDeclineData((prev) => ({
      ...prev,
      [type]: val,
    }));
  };
  const cancelClick = () => {
    closePopDecline();
  };

  const saveClick = () => {
    declineAcceptBsTransferOutRequestApi('decline', declineData);
  };
  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <Box display="flex" className={classes.header}>
          <Box display="flex" alignItems="baseline">
            <Typography className={baseClasses.headerTitle}>{title}</Typography>
          </Box>
          <IconButton className={baseClasses.closeIcon} onClick={closePopDecline} style={{ marginRight: '-10px' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        {showRedirectTo && (
          <Box mb="1rem">
            <Typography className={classes.remarksTitle}>Redirect to</Typography>
            <AutoCompleteSelect
              id="bed_status_transferpop_decline_redirect_to"
              itemList={redirectList}
              placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
              value={declineData?.redirWardId}
              onChange={(val) => onChangeHandle('redirWardId', val)}
            />
          </Box>
        )}
        <Box>
          <Typography className={classes.remarksTitle}>{i18n.t('BEDSTATUS_DECLINE_REMARKS')}</Typography>
          <InputBase
            id="bed_transferpop_Remarks"
            className={baseClasses.inputText}
            style={{ width: '100%', flex: '0 0 3.5rem', marginTop: '0.625rem', marginBottom: '1.625rem' }}
            value={declineData?.remark}
            onChange={(event) => onChangeHandle('remark', event.target.value)}
            placeholder={i18n.t('BEDSTATUS_ADD_DECLINE')}
            inputProps={{
              maxLength: 255,
            }}
          />
        </Box>
        <div>
          <div className={baseClasses.bottom} style={{ marginTop: '0.5rem' }}>
            <ButtonBase
              id="bed_transferpop_cancel"
              className={baseClasses.bottomDeleteBtn}
              style={{ marginRight: '1.25rem', width: '12.5rem', height: '3rem', flexBasis: 'auto' }}
              onClick={cancelClick}
            >
              {i18n.t('BEDSTATUS_CANCEL')}
            </ButtonBase>
            <ButtonBase
              id="bed_transferpop_save"
              className={classNames(baseClasses.bottomSaveBtn, classes.confirmBtnDisabled)}
              onClick={saveClick}
              style={{ marginRight: '1.25rem', width: '12.5rem', height: '3rem', flexBasis: 'auto' }}
              disabled={buttonDisabled}
            >
              {i18n.t('BEDSTATUS_ADD')}
            </ButtonBase>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
